import React from 'react';
import { cn } from '@/utils/cn';
import { useSelector } from 'react-redux';
import useWindowDimensions from '@/app/hooks/useWindowSize';
import {
  screenTypes,
  spinWheelActionTypes,
  statusTypes,
} from '@/constants/types';
import LoadingSpinnerV2 from '../Skeleton/LoadingSpinnerV2';
import Button from '.';
import ButtonLabel from '../Typography/ButtonLabel';

function SpinNowButton({
  label = 'Spin Now',
  className = '',
  disabled = false,
  isOpenModal = false,
  onSpin,
}) {
  const { width: screenWidth } = useWindowDimensions();
  const { resultStatus } = useSelector((state) => state.spinTheWheel);

  const handleSpinNow = async () => {
    if (!isOpenModal) {
      onSpin(spinWheelActionTypes.spinningWheel);
    } else {
      onSpin(spinWheelActionTypes.openModal);
    }
  };

  if (!isOpenModal) {
    return (
      <Button
        type="primary"
        className={cn(
          'w-full mx-auto max-w-[200px] lg:max-w-[296px] !h-[40px] lg:!h-[36px] flex justify-center items-center gap-2 rounded-[100px] bg-tealgreen border border-tealgreen hover:bg-cape-verde',
          {
            '!bg-aquarelle-purple !border-himalayan-poppy hover:cursor-not-allowed':
              disabled || resultStatus === statusTypes.loading,
          },
          className,
        )}
        disabled={disabled}
        onClick={(e) => {
          handleSpinNow(e);
        }}
      >
        {resultStatus === statusTypes.loading ? (
          <LoadingSpinnerV2
            size={screenWidth >= screenTypes.large ? '24' : '14'}
            className="bg-transparent"
          />
        ) : null}

        <ButtonLabel
          label={label}
          className={cn(
            'text-white text-center text-sm lg:text-base font-bold',
            {
              'hover:cursor-not-allowed text-atelier':
                resultStatus === statusTypes.loading || disabled,
            },
          )}
        />
      </Button>
    );
  }

  return (
    <Button
      type="primary"
      className="w-full lg:max-w-[320px] h-[40px] rounded-[100px] bg-tealgreen px-24 py-10 border border-tealgreen hover:bg-cape-verde"
      onClick={(e) => handleSpinNow(e)}
    >
      <ButtonLabel
        label={label}
        className="text-white text-center text-sm lg:text-base font-bold"
      />
    </Button>
  );
}

export default SpinNowButton;
